
import '../Inscription.less';
import {Button,Layout,Menu , Row, Col, Modal,Select,ConfigProvider,Table} from 'antd';
import { BarChartOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import moment from 'moment';
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import generatePDFPlaysByCountry from './services/reports'
import {getAuthors,getAuthorsStr, getCountryName,getCountryCode, IP} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
class AdminHome extends Component {
  constructor(props){
    super(props)
    this.state={
      playsByCountry: [],
      todayP: 0,
      todayC: 0,
      totalC: 0,
      totalP: 0 ,
      conc_report:[],
      plays_report:[],
      reportCountry:null,
      makeCountryReport:false
    }
  }
  
async componentDidMount() {
  const plays = await fetch(IP + 'api/composicion/obra/',{
    method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"
  },
  });
  const json_plays = await plays.json();
  if(json_plays['detail']){
    localStorage.clear()
    window.location.reload(); 
  }
   
  const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc}))
  var data_play = []
  
  const Moment = require('moment');
  for(var i in json_plays){
    var item = json_plays[i];
    var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
    var author= getAuthors(item.conc)
    var authorStr = getAuthorsStr(item.conc).join(", ")
    const year = date.split('-')[2]
    data_play.push(
        { 
            id : i,
            title : item.titulo,
            author: author ,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.id,
            conc:item.conc,
            pdf:item.pdf,
            edit:''
        });
  };
    
    var conc_data = []
    for(var i in json_conc){
      var item = json_conc[i];
      conc_data.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
          });
    };
    var todayP = 0
    var totalP = 0

    var todayC = 0
    var totalC = 0
    var playsByCountry={ }
    for(var key in json_plays){
      var play = json_plays[key]
      
      var country = play['conc'][0]['pais']
      var countryName =getCountryName(country)
      if(!(countryName in playsByCountry)){
        playsByCountry[countryName] ={"today":0,"total":0}
      }
      var playDate = moment(play.fecha_registro).format('DD-MM-YYYY')
      var today = moment().format('DD-MM-YYYY')

      if(today == playDate){
        todayP += 1
        playsByCountry[countryName]["today"] += 1
        for(var aut in play.conc){
          todayC +=1
        }
      }
      totalP += 1
      playsByCountry[countryName]["total"] += 1
      totalC += Object.keys(play.conc).length
    }
    this.setState({  
      conc_report: conc_data, 
      plays_report: data_play,
      playsByCountry: playsByCountry,
      todayP:todayP,
      todayC:todayC,
      totalC:totalC,
      totalP:totalP });
  }
  render() {
    const {   Content } = Layout;
    const dataC = [
      {
        key: '1',
        todayC: this.state.todayC,
        totalC: this.state.totalC,
      },
    ];
    const { Option } = Select;
    var dataByCountry =  Object.keys(this.state.playsByCountry).map((country,index)=>
      {
        var row = {
          key:index,
          country:country,
          today:this.state.playsByCountry[country]["today"],
          total:this.state.playsByCountry[country]["total"]
        }
        return row
      })

    const  data = dataByCountry.sort((a, b) => a.country.localeCompare(b.country))
    const dataP = [
      {
        key: '1',
        todayP: this.state.todayP,
        totalP: this.state.totalP,
      }
    ];

    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")


    const downloadConcReport =()=> generatePDFConc(this.state.conc_report,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc_report,"read")

    const downloadPlayCountryReport =()=> generatePDFPlaysByCountry(data,"save")
    const readPlayCountryReport =()=> generatePDFPlaysByCountry(data,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

    const onClickCountryReport=()=>{
      this.setState({makeCountryReport:true})
    }
    const onClosekCountryReport=()=>{
      this.setState({makeCountryReport:false})
    }
    const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}

    const { SubMenu } = Menu;
    const { Column, ColumnGroup } = Table;
    const reportsMenu =(
      <SubMenu key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
        <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
                <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>Por países</h4>}>
            <Menu.Item>
              <Button onClick={readPlayCountryReport}>Ver</Button> <Button onClick={downloadPlayCountryReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.Item>
              <h4 onClick={onClickCountryReport}  style={{  color:'black'}}>Por país específico</h4>
          </Menu.Item>
        </SubMenu>
        <SubMenu   title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
          <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
              <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
      </SubMenu>
    )
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <AdminMenu defaultSelectedKey={"home"} reportMenu={reportsMenu} />
              <Content>
                <Row  justify="center" align="middle" >
                  <Col span={6}>
                    <br></br>
                    <Table bordered dataSource={dataP} pagination={false} size='small' style={{fontSize:'large'}} >
                      <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/composicion/admin_plays_list">Obras</NavLink> </div>}>
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayP" key="todayP" align='center' render = {(text,record)=> {
                          return {
                            props: {
                              style: { background:  "white",fontSize:'large' }
                            },
                            children: <div>{text}</div>
                          }} } />
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)}dataIndex="totalP" key="totalP"  align='center'render = {(text,record)=> {
                          return {
                            props: {
                              style: { background: "white",fontSize:'large' }
                            },
                            children: <div>{text}</div>
                          }} } />
                      </ColumnGroup>
                    </Table>
                    <br/>
                    <Row  justify="center" align="middle"  >
                      <Col span={24} >
                        <Table  bordered dataSource={dataC} pagination={false}size='small' >
                          <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/composicion/admin_conc_list">Concursantes</NavLink></div>}>
                            <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayC" key="todayC" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                            <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)} dataIndex="totalC" key="totalC" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                          </ColumnGroup>
                        </Table>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={6}>
                    <br></br>
                    <Table bordered dataSource={data} pagination={false} size='small' style={{fontSize:'large', marginLeft:'10px'}} >
                      <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/composicion/admin_plays_list">Obras</NavLink> </div>}>
                        <Column
                          title={(<div style={{ fontWeight:'bold', fontSize:'x-large'}}> País</div>)} 
                          dataIndex="country" key="country" align='center'
                          render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background: "white",fontSize:'large' }
                                },
                                children: <div>{text}</div>
                              }} }
                          
                        />
                        <Column title={(<div style={{  fontSize:'large'}}>Hoy</div>)} dataIndex={"today" } key="today" align='center' render = {(text,record)=> {
                          return {
                            props: {
                              style: { background:"white",fontSize:'large' }
                            },
                            children: <div>{text}</div>
                          }} } 
                        />
                        <Column title={(<div style={{ fontSize:'large'}}>Total</div>)}dataIndex={"total" } key="total"  align='center'render = {(text,record)=> {
                          return {
                            props: {
                              style: { background:  "white",fontSize:'large' }
                            },
                            children: <div>{text}</div>
                          }} } />
                      </ColumnGroup>
                    </Table>
                    <br/>
                  </Col>
                </Row>
                {this.state.makeCountryReport &&
                <Modal
                  closable = {false}
                  title="Reporte por país"
                  visible={this.state.makeCountryReport}
                  footer={[
                    <Button key="back" onClick={onClosekCountryReport}>
                    Regresar
                    </Button>,
                    ]}
                >
                    <Select
                      style={{width:'80%'}}
                      defaultValue={this.state.reportCountry}
                      onChange={onChangeReportCountry}
                    >
                      {Object.entries(data).map(element => {return <Option value={element[1].country}>{element[1].country}</Option>})}
                    </Select>
                      <div>
                        <br/>
                        <Button onClick={readPlayReportSelectedCountry}>Ver</Button> <Button onClick={downloadPlayReportSelectedCountry}>Descargar</Button>
                      </div>
                  </Modal>}
              </Content>
            </Layout>
          </ConfigProvider>
        </div>
      <Foot admin={true}/>
    </div>
    );
  }
}
export default AdminHome;


